import React, { Component } from 'react'
import {Link} from 'react-router-dom'
import {CurrentRankingStyle} from './../../styles'
import { fetchPage } from '../../services/ApiController'
import { connect } from 'react-redux'
import Router from '../../services/Router'

class CurrentRanking extends Component {

  static defaultProps = {
    preview: false
  }

  getSup = (sup) => {
    let str = '' 
    switch (sup) {
      case 1:
      case 31:
        str = 'st'
        break;
      case 2:
        str = 'nd'
        break;
      case 3:
        str = 'rd'
        break;
    
      default:
        str = 'th'
        break;
    }

    return str
  }

  render() {
    const { preview, current, total, score } = this.props
    return (
      <div className={`current-ranking ${CurrentRankingStyle(preview)} `}>
        <div className="current-ranking-label">
          {
            preview ? 'My ranking' : 'current ranking'
          }
        </div>
        <div className="current-ranking-number">
          <span className="current">
            { score ? current : '-' }
            {
              score && !preview ? <sup>{this.getSup(current)}</sup> : null
            }
          </span>
          {
            score && preview ?  <span className="all"> /{ total } </span> : null
          }
        </div>
        {
          !preview && (
            <Link to={Router.ranking.exactPath} className="link"> View general ranking </Link>
          )
        }
      </div>
    )
  }
}

export default connect(
  ({ Session }) => ({
    total: Session.challenge.quizzTotal,
    current: Session.challenge.current,
    score: Session.challenge.quizz
  })
)(CurrentRanking)


// WEBPACK FOOTER //
// ./src/components/Challenge/CurrentRanking.js